var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "section",
      { staticClass: "trial-balance-wrapper" },
      [
        _c(
          "b-row",
          { staticClass: "trial-balance justify-content-center" },
          [
            _c(
              "b-col",
              { attrs: { cols: "10" } },
              [
                _c(
                  "b-card",
                  {
                    staticClass: "trial-balance-card",
                    attrs: { "no-body": "" },
                  },
                  [
                    _c(
                      "b-card-body",
                      { staticClass: "trial-balance-padding pb-0" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex justify-content-center flex-md-row flex-column mt-0",
                          },
                          [
                            _c("div", { staticClass: "text-center" }, [
                              _c("h1", { staticClass: "trial-balance-logo" }, [
                                _vm._v(_vm._s(this.userData.username)),
                              ]),
                              _c("h1", { staticClass: "trial-balance-title" }, [
                                _vm._v("Trial Balance"),
                              ]),
                              _c("h3", [
                                _vm._v(
                                  "As of " +
                                    _vm._s(
                                      new Date().toISOString().split("T")[0]
                                    )
                                ),
                              ]),
                            ]),
                          ]
                        ),
                      ]
                    ),
                    _c("hr", { staticClass: "trial-balance-spacing" }),
                    _c(
                      "b-card-body",
                      { staticClass: "trial-balance-padding py-4" },
                      [
                        _c("b-table-lite", {
                          attrs: {
                            items: _vm.tableData,
                            fields: _vm.fields,
                            responsive: "",
                            bordered: "",
                            striped: "",
                            hover: "",
                            "tbody-tr-class": _vm.tbodyTrClass,
                          },
                        }),
                        _c(
                          "b-row",
                          { staticClass: "w-100" },
                          [
                            _c(
                              "b-col",
                              { staticClass: "mt-2", attrs: { cols: "6" } },
                              [
                                _c("h5", { staticClass: "text-uppercase" }, [
                                  _vm._v("Total"),
                                ]),
                              ]
                            ),
                            _c(
                              "b-col",
                              {
                                staticClass:
                                  "mt-xl-0 mt-2 d-flex justify-content-end",
                                attrs: { cols: "6" },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "font-weight-bolder justify-content-end text-right",
                                  },
                                  [
                                    _c("hr", { staticClass: "my-50" }),
                                    _c(
                                      "p",
                                      { staticClass: "card-text mb-25" },
                                      [
                                        _vm._v(
                                          "Debit: " +
                                            _vm._s(
                                              _vm._f("formatCurrency")(
                                                _vm.getTotalDebit()
                                              )
                                            )
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "p",
                                      { staticClass: "card-text mb-25" },
                                      [
                                        _vm._v(
                                          "Credit: " +
                                            _vm._s(
                                              _vm._f("formatCurrency")(
                                                _vm.getTotalCredit()
                                              )
                                            )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }